
import React from "react";
import MainLayout from "../../components/layout/MainLayout";
import Commercialization from "../../components/admin/Commercialization";

const AdminCommercialization: React.FC = () => {
  return (
    <MainLayout>
      <Commercialization />
    </MainLayout>
  );
};

export default AdminCommercialization;
